module.exports = __webpack_public_path__ + "static/media/DC_O_Jacquard_Meda_Ind.Blue_Peri.5a04bb43.png";